
namespace Matrix.Data {

    let systemWorksheetNames = {
        "log": 1,
        "parameters": 1,
        "release notes": 1,
        "system": 1,
        "transform": 1,
        "workflow": 1
    };

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class DataReportsDialog extends Serenity.EntityDialog<DataReportsRow, any> {
        protected getFormKey() { return DataReportsForm.formKey; }
        protected getIdProperty() { return DataReportsRow.idProperty; }
        protected getLocalTextPrefix() { return DataReportsRow.localTextPrefix; }
        protected getNameProperty() { return DataReportsRow.nameProperty; }
        protected getService() { return DataReportsService.baseUrl; }

        protected form = new DataReportsForm(this.idPrefix);

        constructor() {
            super();

            this.form.QueryType.change(e => this.updateInterface());

            this.form.ObjectName.changeSelect2(e => {
                this.form.ColumnList.value = [];
                this.form.ParameterList.value = [];
                this.form.VisibleSheets.sheetNames = [];
                this.form.VisibleSheets.value = [];

                if (!Q.isTrimmedEmpty(this.form.ObjectName.value)) {
                    this.updateParameters();
                    this.updateColumns();

                    if (this.form.QueryType.value == DataQueryType.Workbook.toString()) {
                        DataReportsService.ListSheets({
                            TemplateKey: this.form.ObjectName.value
                        },
                            response => {
                                this.form.VisibleSheets.sheetNames = response.Entities || [];
                                this.form.VisibleSheets.value = response.Entities.filter(x => !systemWorksheetNames[(x || "").toLowerCase()]);
                            });
                    }
                }
            });

            this.form.DynamicSql.change(e => {
                if (!Q.isTrimmedEmpty(this.form.DynamicSql.value)) {
                    this.updateParameters();
                    this.updateColumns();
                }
            });

            this.form.ParameterList.updateParameters = () => this.updateParameters();
            this.form.ColumnList.updateColumns = () => this.updateColumns();
            
        }

        protected updateParameters() {
            var queryType = Q.toId(this.form.QueryType.value) as DataQueryType;
            if (!queryType) {
                Q.notifyWarning("Please select query type first!");
                return;
            }

            var objectName = this.form.ObjectName.value;
            if (queryType != DataQueryType.SQL && !objectName) {
                Q.notifyWarning("Please fill in object name first!");
                return;
            }

            var sql = Q.trimToEmpty(this.form.DynamicSql.value)

            if (queryType == DataQueryType.SQL && !sql) {
                Q.notifyWarning("Please fill in dynamic SQL first!");
                return;
            }

            DataReportsService.ListParameters({
                QueryType: queryType,
                ObjectName: objectName,
                Sql: sql
            }, response => {
                var oldByName: Q.Dictionary<DataParameter> = {};
                for (var k of (this.form.ParameterList.value || []))
                    oldByName[k.Name] = k;

                this.form.ParameterList.value = (response.Entities || []).map(x => {
                    var old = oldByName[x.Name];
                    if (old) {
                        old.Type = x.Type;
                        old.Size = x.Size;
                        old.Scale = x.Scale;
                        return old;
                    }
                    return x;
                });
            });
        }

        protected updateColumns() {
            var queryType = Q.toId(this.form.QueryType.value) as DataQueryType;

            // column is not applicable for mx-transform
            if (queryType == DataQueryType.Workbook) {
                return;
            }

            if (!queryType) {
                Q.notifyWarning("Please select query type first!");
                return;
            }

            var objectName = this.form.ObjectName.value;
            if (queryType != DataQueryType.SQL && !objectName) {
                Q.notifyWarning("Please fill in object name first!");
                return;
            }

            var sql = Q.trimToEmpty(this.form.DynamicSql.value)

            if (queryType == DataQueryType.SQL && !sql) {
                Q.notifyWarning("Please fill in dynamic SQL first!");
                return;
            }

            var parameterValues: Q.Dictionary<string> = {};
            var listColumns = () => {
                DataReportsService.ListColumns({
                    QueryType: queryType,
                    ObjectName: objectName,
                    Sql: sql,
                    ParameterValues: parameterValues
                }, response => {

                    var oldByName: Q.Dictionary<DataReportColumn> = {};
                    for (var k of (this.form.ColumnList.value || []))
                        oldByName[k.Name] = k;

                    this.form.ColumnList.value = (response.Entities || []).map(x => {
                        var old = oldByName[x.Name];
                        if (old) {
                            old.Type = x.Type;
                            old.Size = x.Size;
                            old.Scale = x.Scale;
                            return old;
                        }
                        return x;
                    });
                }, {
                        onError: (response: Serenity.ServiceResponse) => {
                            if (response && response.Error && response.Error.Code == "MISSING_PARAMETER_VALUES") {
                                var paramList = JSON.parse(response.Error.Arguments) as DataParameter[];
                                var dlg = new StoredProcParametersDialog();
                                dlg.setParameters(paramList);
                                dlg.okClick = () => {
                                    parameterValues = dlg.getParameterValues();
                                    dlg.dialogClose();
                                    listColumns();
                                };
                                dlg.dialogOpen();
                            }
                        }
                });
            };
            listColumns();
        }

        protected updateInterface() {
            super.updateInterface();

            var queryType = Q.toId(this.form.QueryType.value) as DataQueryType;

            var showObjectName = queryType == DataQueryType.StoredProc ||
                                queryType == DataQueryType.Table ||
                                queryType == DataQueryType.View ||
                                queryType == DataQueryType.Workbook;

            this.form.ObjectName.getGridField().toggle(showObjectName);
            Serenity.EditorUtils.setRequired(this.form.ObjectName, showObjectName);
            if (!showObjectName)
                this.form.ObjectName.value = null;

            var showSql = queryType == DataQueryType.SQL;

            this.form.DynamicSql.getGridField().toggle(showSql);
            Serenity.EditorUtils.setRequired(this.form.DynamicSql, showSql);
            if (!showSql)
                this.form.DynamicSql.value = null;

            var showParameters = queryType == DataQueryType.StoredProc ||
                                queryType == DataQueryType.SQL ||
                                queryType == DataQueryType.Workbook;
            this.form.ParameterList.getGridField().toggle(showParameters);
            if (!showParameters)
                this.form.ParameterList.setItems([]);
            this.form.ParameterList.slickGrid.invalidate();
            this.form.ParameterList.element.triggerHandler('layout');

            var showColumns = queryType != null && queryType != DataQueryType.Workbook;

            this.form.ColumnList.getGridField().toggle(showColumns);
            this.form.ExpandAllGroups.getGridField().toggle(showColumns);
            this.form.FrozenColumns.getGridField().toggle(showColumns);

            this.form.VisibleSheets.getGridField().toggle(queryType == DataQueryType.Workbook)
            this.form.VisibleSheets.element.trigger('layout');

            Serenity.EditorUtils.setRequired(this.form.FrozenColumns, showColumns);
            var isWorkbook = queryType === DataQueryType.Workbook;
            this.form.ReadonlyWorkbook.element.parent().toggle(isWorkbook);
            this.form.ShowWorkbookInsertTab.element.parent().toggle(isWorkbook);
            this.form.ShowWorkbookFormulasTab.element.parent().toggle(isWorkbook);
            this.form.ShowWorkbookDataTab.element.parent().toggle(isWorkbook);
            this.form.ShowWorkbookReviewTab.element.parent().toggle(isWorkbook);
            this.form.ShowWorkbookViewTab.element.parent().toggle(isWorkbook);
            this.form.WorkbookHeight.element.parent().toggle(isWorkbook);
            this.form.WorkbookFullScreenMode.element.parent().toggle(isWorkbook);
        }

        protected updateSheets() {

        }

        protected loadEntity(entity: DataReportsRow) {
            super.loadEntity(entity);

            if (entity.QueryType == DataQueryType.Workbook && entity.ObjectName) {
                DataReportsService.ListSheets({
                    TemplateKey: entity.ObjectName
                }, response =>
                    {
                        this.form.VisibleSheets.sheetNames = response.Entities || [];
                        this.form.VisibleSheets.value = (entity.PropertiesObject || {}).VisibleSheets || [];
                    });
            }
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            if (entity["VisibleSheets"] != null) {
                entity.PropertiesObject = entity.PropertiesObject || {};
                entity.PropertiesObject.VisibleSheets = entity["VisibleSheets"];
                delete entity["VisibleSheets"];
            }
            return entity;
        }
    }
}